import React, { useEffect, useState } from 'react';
import { ImCancelCircle } from 'react-icons/im';
import Modal from 'react-modal';
import ATWorkingActivitiesLogFormCom from './ATWorkingActivitiesLogFormCom';

function ATWorkingActivitiesLogCreateModal(
  { 
    isOpen, 
    onClose,
    assigned_technician_id,
    setModalOpen,
}) 
  {

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Purchased Details Modal"
      className="modal"
      overlayClassName="overlay"
    >
      <div className='mb-2 w-[360px] md:w-[600px] lg:w-[600px] overflow-y-auto h-[300px]'>
        <div className='modal-title flex justify-between bg-[#fff] text-[#EB5757] text-[18px] px-3 py-2 rounded-[5px] mb-10 shadow fixed top-0 left-0 right-0 z-50'>
          <h1 className='font-semibold uppercase'>Workin Activities Log</h1>
          <button className='text-[#000]' onClick={onClose}><ImCancelCircle /></button>
        </div>

          <div>
              <ATWorkingActivitiesLogFormCom 
                  assigned_technician_id={assigned_technician_id}
                  setModalOpen={setModalOpen}
              />
          </div>
      </div>
    </Modal>
  );
}

export default ATWorkingActivitiesLogCreateModal;